import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    // user pages
    {
      path: '/app',
      meta: {
        requiresAuth: true,
      },
      component: () => import('@/views/layout/Index'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: '',
          component: () => import('@/views/app/Dashboard'),
        },
        // Account Details
        {
          name: 'Account Details',
          path: 'account/:key',
          component: () => import('@/views/app/account/AccountDetails'),
          props: (route) => ({
            // user: userData,
            ...route.params,
          }),
        },
        // Pages
        {
          name: 'User Profile',
          path: 'user/profile',
          component: () => import('@/views/user/Profile'),
        },
      ],
    },
    // admin pages
    {
      path: '/admin',
      meta: {
        requiresAuth: true,
        requiresStaff: true,
        requiresAdmin: true,
      },
      component: () => import('@/views/layout-staff/Index'),
      beforeEnter: (to, from, next) => {
        if (!store.state.authModule.isAdmin) {
          next({
            path: '/app',
          })
        } else next()
      },
      children: [
        // Manage Users
        {
          name: 'Manage Users',
          path: 'manage-users',
          component: () => import('@/views/admin/ManageUsers'),
        },
      ],
    },
    {
      path: '/entrance/login',
      component: () => import('@/views/entrance/Login'),
    },
    {
      path: '/signup/new',
      component: () => import('@/views/signup/index'),
    },
    {
      path: '/signup/upgrade',
      component: () => import('@/views/signup/upgrade'),
    },
    {
      name: 'Appointment',
      path: '/appointment',
      meta: {
        // requiresAuth: true
      },
      component: () => import('@/views/entrance/appointment'),
      props: (route) => ({ apptID: route.query.apptID, secret: route.query.secret }),
    },

    // Admin
    {
      name: 'Admin',
      path: '/admin',
      meta: {
        requiresAdmin: true,
      },
      component: () => import('@/views/layout/Index'),

      children: [
        // Settings
        {
          name: 'Settings',
          path: 'settings',
          component: () => import('@/views/admin/Settings'),
        },
      ],
    },
    // PublicReporting - nm batch
    {
      name: 'Public Report NM Batch',
      path: '/public-reporting/nm-batch',
      meta: {
        // requiresAdmin: true,
      },
      component: () => import('@/views/public-report/NmBatchSummary'),
    },
    // PublicReporting
    {
      name: 'Public Report Invoice',
      path: '/public-reporting/invoice',
      meta: {
        // requiresAdmin: true,
      },
      component: () => import('@/views/public-report/TestInvoice'),
    },
    // PublicTestReporting
    {
      name: 'Public Test Report Invoice',
      path: '/public-reporting/invoice',
      meta: {
        // requiresAdmin: true,
      },
      component: () => import('@/views/public-report/TestInvoice'),
    },
    // PublicReporting - receipt
    {
      name: 'Public Test Report Invoice',
      path: '/public-reporting/payment-receipt',
      meta: {
        // requiresAdmin: true,
      },
      component: () => import('@/views/public-report/PaymentReceipt'),
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to) {
    store.commit('SET_ACTIVE_PAGE', to)
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.authModule.isLoggedIn) {
      next({
        path: '/login',
      })
    } else if (store.state.authModule.isLoggedIn) {
      next()
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresAdmin)) {
    console.log('Requires superadmin')
    console.log(to)
    if (!store.state.auth.isSuperAdmin) {
      console.log('nav to dashboard, invalid perms')
      next({
        path: '/',
      })
      // next();
    } else {
      next()
    }
  } else {
    if (store.state.authModule.isLoggedIn && to.path === '/login') {
      console.log('nav to dashboard')
      next({
        path: '/app',
      })
      // next();
    }
    next()
  }
})

export default router
